import { createAsyncThunk } from '@reduxjs/toolkit';
import createNotification from '../../../../utils/createNotification';

export const GetTimelineById = createAsyncThunk(
    'timelines/getTimelineById',
    async (arg: { id: number; isTemplate: boolean }, dispatch: any) => {
        const axios = dispatch.getState().core.axios;

        try {
            const response = await axios.get(
                arg.isTemplate
                    ? `/api/Marketplace/TimelineTemplates/${arg.id}`
                    : `/api/Marketplace/Engagements/${arg.id}`
            );

            if (response.status !== 200) {
                throw new Error('Failed to fetch Timeline Template');
            }

            return response.data;
        } catch (error) {
            createNotification(
                `There was an error while loading ${
                    arg.isTemplate ? 'Timeline Template' : 'Engagement'
                } Timeline.`,
                'error'
            );
            throw error;
        }
    }
);
